import { reducer as tracking_reducer } from 'entities/device.map.track/model/reducer';
import { create_reducer as create_ui_settings_reducer } from './settings-actions';
import { reducer as terminal_reducer } from 'console/shared/components/panels/terminal/redux/reducer';
import { reducer as toast_reducer } from '../dialogs/toast';
import { reducer as app_settings_reducer } from '../app-settings/redux/reducer';
import { z3k_analog_output_value_reducer } from './z3k-analog-output-value/reducer';
import { reducer as radiosilence_reducer } from '../radio-silence-dialog/reducer';
import { reducer as ztc_config_download_reducer } from './ztc-config-download.actions';
import { reducer as sx_config_download_reducer } from 'console/redux/sx-config/reducer';
import { create_reducer as create_news_reducer } from 'console/redux/news/actions';
import upgrade_soft_reducer from '../device-settings/upgrade-dialog/redux/reducer';
import { AlienServiceReducer, reducer as account_dialog_reducer, } from 'shared/account.settings/redux/reducer';
import { climatic_mode_loading_reducer } from '../climatic/reducer';
import { reducer as climatic_settings_reducer } from '../climatic/settings-actions';
import { reducer as stock_configs_reducer } from 'console/device-settings/z3k/components/main-settings/stock-configs/redux/reducer';
import { reducer as periodReducer } from '../period/reducer';
import { reducer as selectingDevicesDialogReducer } from '../selecting-devices-dialog/reducer';
import { reducer as events_reducer } from 'console/tabs/events/redux/reducer';
import { uiGuideReducer } from 'console/ui-guide/redux/reducer';
import { reducer as renameGroupDialogReducer } from '../sortableDeviceTree/rename-group-dialog/reducer';
import { reducer as groupSelectorDialogReducer } from '../sortableDeviceTree/add-group-selector-dialog/reducer';
import { reducer as replace_dialog_reducer } from '../replaceDeviceDialog/reducer';
import { reducer as configured_dialog_reducer } from 'console/baxi/entities/master-settings/redux/reducer';
import { reducer as transfer_dialog_reducer } from '../transferDeviceDialog/reducer';
import { reducer as delete_dialog_reducer } from '../leftPanel/deleteDeviceDialog/reducer';
import { reducer as error_dialog_reducer } from '../dialogs/error/redux/reducer';
import { treeLastUpdateTimeReducer } from './devices/time';
import { geozoneReducer, upload_geozones_reducer, } from 'entities/map.geozone/model/reducer';
import { upload_attachments_reducer } from 'console/tabs/maintenance/Actions_Reducers/history-maintenance-reducer';
// #if brand.show_photos
// import { photosReducer } from 'entities/device.photos/model/get-photos-reducer';
import { photosByPeriodReducer } from 'entities/device.photos/model/get-photos-by-period-reducer'; // #endif
import { addDeviceDialog } from '../leftPanel/add-device-dialog/device-add-dialog-reducer';
import { reducer as create_zth_dashboard_reducer } from 'console/dashboards/zth/reducer';
import { mapDashboardReducer } from 'pages/dashboard.map/model/store';
import { billingReducer } from '../billing/redux/reducer';
import { tariff_reducer } from '../billing/account-tariff/redux/reducer';
import { create_account_reducer, propopup_reducer } from '../account/redux/reducer';
import { miniMapReducer } from 'widgets/map.corner/model/reducer';
import { scrollRandomReducer } from '../sortableDeviceTree/redux/scrollRandom/scroll-random-reducer';
import { opentherm_errcodes_reducer } from './opentherm-errcodes/reducer';
import { reducer as baxi_service_tab_reducer } from 'console/baxi/widgets/service/model/reducer';
import { serverTimeReducer } from './server-time-reducer';
import { importantEventsReducer } from './important-events-reducer';
import { importantEventsDialogReducer } from './important-events-dialog-reducer';
import { lastFirmwaresReducer } from './last-firmwares-reducer';
import { eventOnMapReducer } from './event-on-map-reducer';
import { settingEmailReducer } from './setting-email-reducer';
import { snakeErrorReducer } from 'console/dialogs/error/snake-error/redux/reducer';
import { widgetTypesReducer } from './widget-types-reducer';
import { AlienAppsUrlsReducer } from 'console/features/account.settings/ui/archive/alien-apps-actions'; //#if brand.enable_sim
import { reducer as sim_dialog_reducer } from 'console/sim/redux/reducer';
import { reducer as z3k_settings_reducer, UpdateRouterDeviceIdReducer, } from 'z3k-settings/redux/reducer'; //#endif
import { devicesReducer } from 'entities/device/lib';
import { idleReducer } from 'console/idle/reducer';
import { boilerModelsReducer } from 'console/redux/boiler-models/reducer';
import { z3k_target_temp_reducer } from 'console/redux/z3k-target-temp/reducer';
import { z3k_custom_command_reducer } from 'console/redux/z3k-custom-command/reducer';
import { z3k_device_history_reducer } from 'console/device-settings/z3k/components/view-config/redux/reducer';
import { accessSuggestionsReducer } from 'entities/device.acl.suggestion/model/slice';
import { privateSettingsReducer } from 'entities/device.private_settings/model/slice';
import { userIcons } from 'features/account.settings/ui/icon-settings/reducer/reducer';
import { accessRequestsReducer } from 'entities/device.acl.request/model/slice';
import { requestSupportFormReducer } from 'shared/support.request/model';
import { sessionEndReducer } from 'features/account.session-ended/model/reducer';
import { updateIOExtensionFirmwareReducer } from 'shared/components/banners/update-io-extension/model/slice';
import { supportChatReducer } from 'entities/support.chat/model/store';
import { storiesUi } from 'entities/stories/utils/redux/stories-reducer';
import { deviceSpecReducer } from 'console/redux/device_spec/actions';
import { updateVersionReducer } from 'entities/user.update_app/model/slice';
import { mapReducer } from 'shared/map/model/slice';
import { reviewReducer } from 'console/redux/review-reducer';
import { lastAccessoriesFirmwaresReducer } from 'entities/device.service.accessories.upgrade/model/reducer';
export const reducers = (PRELOAD) => ({
    server_time: serverTimeReducer(PRELOAD),
    account: create_account_reducer(PRELOAD.account),
    idle: idleReducer,
    ot_errcodes_cache: opentherm_errcodes_reducer,
    important_events: importantEventsReducer(PRELOAD),
    event_on_map: eventOnMapReducer,
    adding_device: addDeviceDialog,
    important_events_dialog_open: importantEventsDialogReducer,
    last_firmwares: lastFirmwaresReducer(PRELOAD),
    last_accessories_firmwares: lastAccessoriesFirmwaresReducer,
    setting_email_state: settingEmailReducer,
    tracking: tracking_reducer,
    events: events_reducer,
    ui_settings: create_ui_settings_reducer(PRELOAD),
    map: mapReducer,
    terminal: terminal_reducer,
    access_suggestions: accessSuggestionsReducer,
    access_requests: accessRequestsReducer,
    update_version: updateVersionReducer,
    toast: toast_reducer,
    app_settings: app_settings_reducer,
    zth_dashboard: create_zth_dashboard_reducer(PRELOAD),
    map_dashboard: mapDashboardReducer,
    z3k_settings: z3k_settings_reducer,
    z3k_analog_output_value: z3k_analog_output_value_reducer,
    z3k_custom_command: z3k_custom_command_reducer,
    z3k_target_temp: z3k_target_temp_reducer,
    z3k_device_config_history: z3k_device_history_reducer,
    radiosilence_dialog: radiosilence_reducer,
    ztc_config_download: ztc_config_download_reducer,
    sx_config_download: sx_config_download_reducer,
    news: create_news_reducer(PRELOAD),
    request_support_form: requestSupportFormReducer,
    account_dialog: account_dialog_reducer,
    billing: billingReducer(PRELOAD),
    tariffs: tariff_reducer,
    boiler_models: boilerModelsReducer,
    climatic_mode_loading: climatic_mode_loading_reducer,
    climatic_settings: climatic_settings_reducer,
    upgrade_soft: upgrade_soft_reducer,
    stock_configs: stock_configs_reducer,
    replace_dialog: replace_dialog_reducer,
    configured_dialog: configured_dialog_reducer,
    transfer_dialog: transfer_dialog_reducer,
    delete_dialog: delete_dialog_reducer,
    error_dialog: error_dialog_reducer,
    device_tree_update_time: treeLastUpdateTimeReducer,
    router_device_id: UpdateRouterDeviceIdReducer,
    geozones: geozoneReducer(PRELOAD),
    geozones_uploading_info: upload_geozones_reducer,
    maintenance_attachment: upload_attachments_reducer,
    ui_guide_state: uiGuideReducer(PRELOAD),
    // #if brand.show_photos
//     camera_photos: photosReducer,
//     camera_photos_by_period: photosByPeriodReducer,
    // #endif
    period: periodReducer,
    selecting_devices_ids_dialog: selectingDevicesDialogReducer,
    rename_group_dialog: renameGroupDialogReducer,
    group_selector_dialog: groupSelectorDialogReducer,
    pro_popup: propopup_reducer,
    mini_map: miniMapReducer,
    scrollRandom: scrollRandomReducer,
    baxi_service_tab: baxi_service_tab_reducer,
    snake_error: snakeErrorReducer,
    widget_types: widgetTypesReducer(PRELOAD),
    private_params_dialog: privateSettingsReducer,
    alien_services: AlienServiceReducer,
    alien_app_urls: AlienAppsUrlsReducer,
    //#if brand.enable_sim
    sim_dialogs: sim_dialog_reducer,
    // #endif
    devices: devicesReducer(PRELOAD),
    user_icons: userIcons,
    ui_stories_ids: storiesUi,
    session_end_dialog: sessionEndReducer,
    update_firmware_external_devices: updateIOExtensionFirmwareReducer,
    support_chat: supportChatReducer,
    device_spec: deviceSpecReducer,
    need_app_review: reviewReducer,
});
